module.exports = __webpack_public_path__ + "img/213a658.jpg";